import React, { Suspense } from 'react';
import LoadingIndicator from '@v2/LoadingIndicator';

const withLazyAndSuspense = (importComponent) => {
  const LazyComponent = React.lazy(importComponent);

  return (props) => (
    <Suspense fallback={<LoadingIndicator text="Loading..."/>}>
      <LazyComponent {...props} />
    </Suspense>
  );
};
export default withLazyAndSuspense;